export const getLoyaltyProgramQuery = () =>
  `{
      loyalty_program {
          end_date
          loyalty_status
          next_status
          items { current target }
          spend { current target }
      }
    }`;
